var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBoldBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.317 14.651c-0.557-0.587-1.343-0.952-2.214-0.952-0.829 0-1.581 0.331-2.131 0.868l0.001-0.001-0.085 0.085-6.133 6.729 0.043-8.219 0.128-10.008c0-0.018 0.001-0.039 0.001-0.060 0-1.684-1.346-3.053-3.021-3.091l-0.004-0h-0.128c-1.775 0.031-3.206 1.462-3.237 3.234l-0 0.003s-0.213 17.929-0.17 18.142l-6.005-6.729c-0.557-0.587-1.343-0.952-2.214-0.952-0.829 0-1.581 0.331-2.131 0.868l0.001-0.001-0.085 0.085c-0.573 0.588-0.926 1.392-0.926 2.278s0.353 1.691 0.927 2.279l-0.001-0.001 11.499 11.839c0.557 0.587 1.343 0.952 2.214 0.952 0.829 0 1.581-0.331 2.131-0.868l-0.001 0.001 0.085-0.085 11.456-11.839c0.573-0.588 0.926-1.392 0.926-2.278s-0.353-1.691-0.927-2.279l0.001 0.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoldBottom);
export default __webpack_public_path__ + "static/media/arrow-bold-bottom.c2b3e171.svg";
export { ForwardRef as ReactComponent };